import React, {useState, useReducer, useImperativeHandle, useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {useForm, Controller} from 'react-hook-form';
import {
  updateShowCardsMemo,
  showCardsSelector,
  UPDATE_ROW_FIELDS_DATA,
  getFormFieldsDataSelector,
  updateFormFieldsData,
  aisCardsSelector,
} from '@ibibo/myaccount-reducer';
import classNames from 'classnames';
import * as S from './AisDetailsForm.styles';
import CTA from '../../../common/CTA/CTA';
import AisUpdateDetailsForm from '../../../common/Form/AisUpdateDetailsForm/AisUpdateDetailsForm';
import Modal from '../../../common/Modal/Modal';
import OtpVerfied from '../../../../../../../onboarding/src/stories/components/OnboardingNew/CommonComponents/OtpVerified/OtpVerified';
import UpdateDetailsForm from '../../../common/Form/UpdateDetailsForm/UpdateDetailsForm';

const AisDetailsForm = React.forwardRef((props, ref) => {
  const dispatch = useDispatch();
  const showCardsMemoData = useSelector(showCardsSelector);
  const formFieldsData = useSelector(getFormFieldsDataSelector);

  const modalsInitialState = {
    formModal: true,
    verificationStatusModal: false,
    updateAgentsDetail: false,
  };
  const {componentData, customClass, componentName, sendTrackingDataToSdk} = props;
  const {component, data} = componentData;
  const showCardMemo = useSelector(showCardsSelector);
  const [modalFlag, setModalFlag] = useState(false);
  const [modalType, setModalType] = useState({
    ...modalsInitialState,
  });

  const [modalUpdateDetailsData, setModalUpdateDetailsData] = useState({
    componentData: {},
    modalData: {},
  });

  const errorsInitialState = {
    formSubmissionError: '',
    inputBoxError: '',
  };
  const [error, setError] = useState(errorsInitialState);

  const {
    items,
    primaryText,
    secondaryText,
    showItems = true,
    isRootLevelEditable,
    rootEditButton = {ctas: []},
    subForm = [],
  } = data;

  const {ctas = [], isVerified = false, isVerifiedNode} = rootEditButton || {};

  useEffect(() => {
    if (isVerified) {
      const obj = {...showCardsMemoData};
      obj[componentName] = false;
      dispatch(updateShowCardsMemo(obj));
    }
  }, [isVerified]);

  const handleClick = data => {};

  const handleOpenModal = () => {
    setModalFlag(modalFlag => !modalFlag);
  };

  const handleCloseModal = data => {
    setModalFlag(modalFlag => !modalFlag);
    if (modalType?.verificationStatusModal?.showModal) {
      setModalType({...modalsInitialState});
    }
  };

  const popupSuccessCallback = (resp, data) => {
    //setModalData(data);
    const formDataMapOfExistingKeys = {...formFieldsData}; //Copy the reference of map of form fields in redux store

    for (const i in resp?.data) {
      if (i === 'token' || i === 'unlink_token') {
        formDataMapOfExistingKeys[i] = resp.data[i];
      }
    }

    dispatch(updateFormFieldsData({...formFieldsData, ...formDataMapOfExistingKeys}));
    if (resp?.data?.step) {
      const step = resp.data.step;
      const newModalFormData = modalUpdateDetailsData; //Form data for the new modal to show
      newModalFormData.modalData = newModalFormData.componentData?.data[step];
      setModalUpdateDetailsData({...newModalFormData});
    } else if (resp?.data?.isVerified) {
      setModalType(modalType => {
        return {
          formModal: false,
          verificationStatusModal: {showModal: true, ...resp?.data},
          updateAgentsDetail: false,
        };
      });
    }
    setError(errorsInitialState);
  };

  const popupErrorCallback = err => {
    setError({...err, formSubmissionError: err.message});
  };

  const updateNewModalData = data => {
    if (data.modalDataKeyToSend) {
      setModalUpdateDetailsData({
        componentData: componentData,
        modalData: componentData?.data?.[data?.modalDataKeyToSend],
      });
    }
  };

  const setErrorsToInitialState = () => {
    setError(errorsInitialState);
  };

  return (
    <S.ProfileMainWrap>
      <div className={`aisDetailsWrap ${customClass}`}>
        <div className="aisCardHead">
          <div>
            <p className="font26 lineHeight32 latoBlack appendBottom4">{primaryText}</p>
            <p className="font18 lineHeight28">{secondaryText}</p>
          </div>
          {!Object.keys(showCardMemo).includes(componentName) &&
          !showCardMemo[componentName] &&
          isRootLevelEditable ? (
            <div className="editClickable">
              {isVerified ? (
                <>
                  {isVerifiedNode?.data && (
                    <span
                      className={`aisListHeading ${classNames(
                        isVerifiedNode?.data?.styles?.customClasses !== undefined
                          ? isVerifiedNode?.data?.styles?.customClasses
                          : '',
                      )}`}
                    >
                      {isVerifiedNode?.data?.primaryText}
                    </span>
                  )}
                </>
              ) : (
                ctas &&
                ctas?.length > 0 &&
                ctas?.map(({component, data}, index) => {
                  return (
                    <CTA
                      onClickCB={handleClick}
                      component={component}
                      data={data}
                      style={data?.styles}
                      key={index}
                      openModal={() => {
                        updateNewModalData(data);
                        handleOpenModal();
                      }}
                    />
                  );
                })
              )}
            </div>
          ) : (
            <span className="fontGreen alignLeft">{isRootLevelEditable ? 'Verified' : ''}</span>
          )}
        </div>
        {showItems && (
          <ul>
            {items?.length > 0 &&
              items.map((item, idx) => {
                return (
                  <li key={idx} className="aisListItem">
                    {item?.length > 0 &&
                      item.map(({itemText, itemImage, ctas = []}) => {
                        return (
                          <>
                            {itemText && (
                              <p
                                className={`aisListHeading ${classNames(
                                  itemText?.data?.styles?.customClasses !== undefined
                                    ? itemText?.data?.styles?.customClasses
                                    : '',
                                )}`}
                              >
                                {itemText?.data?.primaryText}
                              </p>
                            )}
                            {itemText?.data?.secondaryText && (
                              <p className="flexOne appendLeft16">
                                {itemText?.data?.secondaryText && (
                                  <span className="aisListVal">
                                    {itemText?.data?.secondaryText}
                                  </span>
                                )}
                                {/*========= CAN BE REQUIRED LATER ============== 
                    {item.subText && <span className="aisListSubText">{item.subText}</span>} */}
                              </p>
                            )}
                            <div>
                              {ctas &&
                                ctas?.length > 0 &&
                                ctas?.map(({component, data}, index) => {
                                  return (
                                    <CTA
                                      onClickCB={handleClick}
                                      component={component}
                                      data={data}
                                      style={data?.styles}
                                      openModal={() => {
                                        updateNewModalData(data);
                                        handleOpenModal();
                                        sendTrackingDataToSdk?.(
                                          {
                                            event_detail: {
                                              event_name: 'product_cta-clicked',
                                              event_type: 'user_action',
                                              event_value:
                                                data?.modalDataKeyToSend
                                                  ?.toLowerCase()
                                                  ?.indexOf('mobile') !== -1
                                                  ? 'update_mobile_number'
                                                  : 'update_emailid',
                                            },
                                          },
                                          'SUPPLIER_SETTINGS',
                                        );
                                      }}
                                    />
                                  );
                                })}
                            </div>
                            {/* {item.addLink && <a className="aisAddBtn">{item.addLink}</a>} */}
                          </>
                        );
                      })}
                  </li>
                );
              })}
          </ul>
        )}
        {
          <ul>
            {subForm &&
              data['isRootLevelEditable'] == undefined &&
              !isRootLevelEditable &&
              subForm?.length > 0 && (
                <AisUpdateDetailsForm
                  form={subForm}
                  handleOpenModal={handleOpenModal}
                  handleCloseModal={handleCloseModal}
                  handleClick={handleClick}
                  isModalForm={false}
                />
              )}
          </ul>
        }
      </div>
      {modalFlag && (
        <Modal
          widthClass={
            modalType?.verificationStatusModal?.showModal ? 'modalWidth400' : 'modalWidth720'
          }
          closeBtn={true}
          padding={'24px'}
          onClose={handleCloseModal}
          heightClass={
            //TODO: Need to remove this hardcoding
            modalType?.verificationStatusModal?.showModal
              ? 'modalHeight450'
              : !Array.isArray(modalUpdateDetailsData?.modalData)
              ? ''
              : 'modalHeight650'
          }
        >
          {modalType?.verificationStatusModal?.showModal === true ? (
            <OtpVerfied
              heading={modalType?.verificationStatusModal?.heading}
              subHeading={modalType?.verificationStatusModal?.sub_text}
              headingIcon={true}
              message={modalType?.verificationStatusModal?.message}
              // inportantInfo={'communicationAddress?.sub_text'}
              isOpenDifferentModalFlag={
                modalType?.verificationStatusModal.hasOwnProperty('openDifferentModal')
                  ? false
                  : true
              }
              setModalType={setModalType}
              height={'400px'}
              marginTop={'40px'}
              showLinkButton={true}
              closeModal={modalType?.verificationStatusModal?.CLOSE_MODAL}
              handleCloseModal={handleCloseModal}
              isVerificationSuccessFull={modalType?.verificationStatusModal?.verification_success}
            />
          ) : !Array.isArray(modalUpdateDetailsData?.modalData) ? (
            <UpdateDetailsForm
              {...modalUpdateDetailsData?.modalData}
              successCallback={popupSuccessCallback}
              errorCallback={popupErrorCallback}
              errorMessages={error}
              closeModal={handleCloseModal}
              setModalUpdateDetailsData={setModalUpdateDetailsData}
              componentData={componentData}
              setErrorMessage={setErrorsToInitialState}
            />
          ) : (
            <AisUpdateDetailsForm
              form={subForm}
              handleOpenModal={handleOpenModal}
              handleCloseModal={handleCloseModal}
              handleClick={handleClick}
              setModalType={setModalType}
            />
          )}
        </Modal>
      )}
    </S.ProfileMainWrap>
  );
});

export default AisDetailsForm;
